import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FormViews, ThumbnailKinds } from '@site-mate/dashpivot-shared-library';

import { FormService } from 'app/form/form.service';
import { ErrorHandler } from 'app/shared/service/error-handler.service';

@Component({
  selector: 'cc-workflow-column',
  templateUrl: 'workflow-column.component.html',
  styleUrls: ['workflow-column.component.scss'],
})
export class WorkflowColumnComponent implements OnInit, OnDestroy {
  @Input() columnNumber: number;
  @Input() data: any;
  @Input() template: any;

  private unSubscribe = new Subject<void>();
  loading = false;
  forms = [];
  limit = 15;
  skip = 0;

  constructor(
    private readonly formService: FormService,
    private readonly router: Router,
    private readonly errorHandler: ErrorHandler,
  ) {}

  ngOnInit() {
    this.updateFormsData();
  }

  onScroll() {
    this.updateFormsData();
  }

  updateFormsData() {
    const isThumbAFieldId = (thumb) =>
      ![ThumbnailKinds.CreatedAt, ThumbnailKinds.CreatedBy, ThumbnailKinds.Counter].includes(thumb);
    this.loading = true;

    this.formService
      .listTemplateForms(this.template.id, {
        workflowStep: this.columnNumber + 1,
        limit: this.limit,
        skip: this.skip,
        items: this.template.displayFormThumbnailBy.filter(Boolean).filter(isThumbAFieldId),
        view: FormViews.Workflow,
      })
      .pipe(takeUntil(this.unSubscribe))
      .subscribe(
        (forms) => {
          this.forms = [...this.forms, ...forms];
          this.skip += this.limit;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.errorHandler.handleForDebug(error, {
            error,
            template: this.template,
            data: this.data,
            columnNumber: this.columnNumber,
          });
        },
      );
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }
}
